/**
 * Report Configurations Storage
 *
 * Stores the full report configurations (fields, filters, grouping, etc.)
 * that are created in the Report Builder.
 */

import { createPersistedMockData } from '../mockDataManager';
import type { ReportConfiguration } from '../reportEngine';

/**
 * Default report configurations (empty on first load)
 */
export const defaultReportConfigurations: ReportConfiguration[] = [];

/**
 * Persisted report configurations
 */
export const persistedReportConfigurations = createPersistedMockData(
  'crm_report_configurations',
  defaultReportConfigurations
);
